import { ITransactionDetailsOrder } from "./types";

export default class TransactionDetailsOrder implements ITransactionDetailsOrder {

  status: string;
  secret: string;
  referenceId: string;
  type: string;
  finishedAt: string;
  shoppingDate: string;
  shoppingTime: string;


  constructor(
    status: string,
    secret: string,
    referenceId: string,
    type: string,
    finishedAt: string,
    shoppingDate: string,
    shoppingTime: string) {
    this.status = status;
    this.secret = secret;
    this.referenceId = referenceId;
    this.type = type;
    this.finishedAt = finishedAt;
    this.shoppingDate = shoppingDate;
    this.shoppingTime = shoppingTime;
  }

}
